import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid, Button, GridRow, GridColumn } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { toLower } from 'lodash';

import { clearState } from 'State/actions';
import { Filter, Main } from 'Containers';
import { getControlInfo } from 'State/controlInfo/actions';
import { StudentNotesModal, YesNoDialog } from 'Components';
import { errorToast } from 'Common/ToastHelper';
import { getPreferences } from 'Common/Security/state/selectors';
import { isPreferenceEnabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';
import { createToast, toastType } from 'Common/ToastHelper';

import * as IncomeBracketActions from 'Pages/incomebracket/state/actions';
import * as IncomeBracketSelectors from 'Pages/incomebracket/state/selectors';
import * as ControlInfoSelectors from 'State/controlInfo/selectors';

import { ApplicationGrid } from './components/manageapplication/ApplicationGrid';
import { ApplicationObjects } from './helpers/ApplicationObjects';
import {
  getActiveApplication,
  deleteApplication,
  getAvailableToDecline,
  declineToVerify,
  printLetterByFamilyId,
  clearError,
  resetReprintedFlag,
} from './state/manageapplication/actions';
import {
  fetchApplication,
  clearErrors as clearHubErrors,
} from './state/hub/actions';
import { withReportSubscription } from 'State/report/withReportSubscription';

class ManageApplicationContainer extends ApplicationObjects {
  state = {
    headerType: 'Active',
    columns: this.activeColumns,
    menuOptions: this.activeMenuOptions,
    showNotesModal: false,
    showDeleteModal: false,
    studentData: {},
    deleteApp: {},
  };

  componentDidMount() {
    const {
      location,
      getControlInfo,
      clearState,
      getAvailableToDecline,
      getCurrentIncomeBracket,
    } = this.props;

    getControlInfo(true);
    clearState();
    getAvailableToDecline();
    getCurrentIncomeBracket();

    const params = new URLSearchParams(location.search);

    if (params.has('r')) {
      const button = this.headerRowButtons().find(
        button => toLower(button.value) === toLower(params.get('r'))
      );
      if (button) {
        this.headerChange(button);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (errorToast(this.props, prevProps, 'hubFetchError')) {
      this.props.clearHubErrors();
    } else if (
      this.props.hasFetchedAppForCopying &&
      !prevProps.hasFetchedAppForCopying
    ) {
      this.props.history.push(`/manageapplication/0`, {
        isCopying: true,
      });
    }
    if (errorToast(this.props, prevProps, 'error')) {
      this.props.clearError();
    }
    if (
      this.props.reprintedSuccessfully === true &&
      prevProps.reprintedSuccessfully !== this.props.reprintedSuccessfully
    ) {
      createToast(
        toastType.success,
        'Success',
        'Letter was successfully Re-Printed.'
      );
      this.props.resetReprintedFlag();
    }
  }

  headerRowButtons = () => {
    const {
      allowSecondReview,
      requireSecondReview
    } = this.props;
    return [
      {
        title: 'Active Applications',
        value: 'Active',
        columns: this.activeColumns,
        menuOptions: this.activeMenuOptions,
      },
      {
        title: 'Deleted Applications',
        value: 'Deleted',
        columns: this.deletedColumns,
        menuOptions: this.deletedMenuOptions,
      },
      {
        title: 'Archived Applications',
        value: 'Archived',
        columns: this.archivedColumns,
        menuOptions: this.archivedMenuOptions,
      },
     
      ...(requireSecondReview && allowSecondReview
        ? [
            {
              title: 'Second Review Applications',
              value: 'SecondReview',
              columns: this.secondReviewColumns,
              menuOptions: this.secondReviewMenuOptions,
            },
          ]
        : []),
    ];
  };

  headerChange = button => {
    this.ApplicationGrid.clearFilters(true);
    this.setState({
      headerType: button.value,
      columns: button.columns,
      menuOptions: button.menuOptions,
    });
  };

  onConfirmDelete = (application, deleteStudents) => () => {
    this.props.deleteApplication(
      application.FamilyId,
      deleteStudents,
      this.ApplicationGrid.state.filtered
    );
    this.closeDeleteModal();
  };

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false, deleteApp: {} });
  };

  closeNotesModal = () => {
    this.setState({ showNotesModal: false });
  };

  handleAddNewApplicationClick = () => {
    const { hasIncomeBrackets, FiscalYear } = this.props;
    if (hasIncomeBrackets) {
      this.props.history.push('/manageapplication/0');
    } else {
      createToast(
        toastType.warning,
        'No Income Guidelines',
        `Please import income guidelines for fiscal year ${FiscalYear}`
      );
    }
  };

  render() {
    const {
      headerType,
      columns,
      menuOptions,
      showNotesModal,
      studentData,
      showDeleteModal,
      deleteApp,
    } = this.state;

    const { isReadOnly, loading, availableToDecline } = this.props;

    const buttons = this.headerRowButtons(availableToDecline);

    return (
      <Fragment>
        <Filter title={'Manage Application'} newRow={true}>
          <Grid>
            <GridRow columns={2}>
              <GridColumn width={10}>
                <Button.Group
                  basic
                  className="btn-group--active-group"
                  widths={buttons.length}
                >
                  {buttons.map(button => (
                    <Button
                      key={button.title}
                      basic
                      disabled={loading}
                      className="white"
                      active={headerType === button.value}
                      onClick={e => this.headerChange(button)}
                    >
                      {button.title}
                    </Button>
                  ))}
                </Button.Group>
              </GridColumn>

              <GridColumn width={6} style={{ padding: '0px' }}>
                <Button
                  content="Add New Application"
                  floated="right"
                  onClick={this.handleAddNewApplicationClick}
                />
              </GridColumn>
            </GridRow>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <ApplicationGrid
            columns={columns}
            menuOptions={menuOptions}
            applicationType={headerType}
            onRef={ref => {
              this.ApplicationGrid = ref;
            }}
            availableToDecline={availableToDecline}
          />
        </Main>
        {showNotesModal ? (
          <StudentNotesModal
            open={showNotesModal}
            onClose={this.closeNotesModal}
            isReadOnly={isReadOnly}
            studentData={studentData}
            isApplicationNotes
          />
        ) : (
          undefined
        )}
        {showDeleteModal ? (
          <YesNoDialog
            showDialog={showDeleteModal}
            title={'Delete students from Point of Sale?'}
            question={
              <span>
                Do you also want to delete students associated with this
                application from Point of Sale?
                <br />
                This action can not be undone.
              </span>
            }
            yesCallback={this.onConfirmDelete(deleteApp, true)}
            noCallback={this.onConfirmDelete(deleteApp, false)}
            cancelCallback={this.closeDeleteModal}
            showCancel
          />
        ) : (
          undefined
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const {
    CommonState: { controlInfo },
    ManageApplicationState: { manageApplication, hub },
  } = state;

  return {
    requireSecondReview: controlInfo.data.RequireSecondReview,
    loading: manageApplication.loading,
    hubFetchError: hub.fetchError,
    hasFetchedAppForCopying: Object.keys(hub.dbApplication).length > 0,
    availableToDecline: manageApplication.availableToDecline,
    allowSecondReview: isPreferenceEnabled(
      PreferencesEnum.AllowSecondReview,
      getPreferences(state)
    ),
    allowVerification: isPreferenceEnabled(
      PreferencesEnum.AllowAccessToVerification,
      getPreferences(state)
    ),
    reprintedSuccessfully: manageApplication.reprintedSuccessfully,
    isConfirmationReview: manageApplication.isConfirmationReview,
    FiscalYear: ControlInfoSelectors.fiscalYear(state),
    hasIncomeBrackets: IncomeBracketSelectors.hasIncomeBrackets(state),
  };
};

const mapDispatchToProps = {
  getActiveApplication,
  deleteApplication,
  clearState,
  fetchApplication,
  clearHubErrors,
  getAvailableToDecline,
  declineToVerify,
  getControlInfo,
  printLetterByFamilyId,
  clearError,
  resetReprintedFlag,
  getCurrentIncomeBracket: IncomeBracketActions.getCurrentIncomeBracket,
};

ManageApplicationContainer = withReportSubscription(ManageApplicationContainer);

export const ManageApplication = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageApplicationContainer)
);



// WEBPACK FOOTER //
// ./src/pages/manageapplication/ManageApplication.js